/* eslint-disable react/prop-types */
import * as React from 'react';
import classnames from 'classnames';

import { expandDataProps } from 'utils/helper/common';

import type { Data, SVGDynamicIconCustomColor } from 'types';

export type SVGDynamicIconProps = {
  name: string,
  width: string | number,
  height: string | number,
  clickable?: boolean,
  customColor?: SVGDynamicIconCustomColor | null,
  link?: string,
  disabled?: boolean,
  openInNewTab?: boolean,
  onClick?: (a: any) => void,
  data?: Data,
  href?: string,
  className?: string
};

const SVGDynamicIcon = (
  {
    name,
    width,
    height,
    clickable,
    customColor,
    link,
    disabled,
    openInNewTab = false,
    onClick,
    data,
    className
  }: SVGDynamicIconProps
): JSX.Element => {
  const classes = classnames('svg-dynamic-icon', className, {
    'svg-dynamic-icon--behavior-clickable': onClick || clickable || link,
    'svg-dynamic-icon--disabled': disabled,
    [`svg-dynamic-icon--color-${String(customColor)}`]: customColor,
    [`svg-dynamic-icon--name-${String(name)}`]: name
  });

  const props: React.ComponentProps<'svg'> = {};
  const targetProps: React.ComponentProps<'a'> = {};

  props.className = classes;

  if (onClick && !disabled) {
    props.onClick = onClick;
  }

  if (link) {
    props.href = link;
  }

  if (openInNewTab) {
    targetProps.target = '_blank';
  }

  // icon will be centered automatically inside the defined boundaries
  const style: React.CSSProperties = {
    width,
    height
  };

  const icon = (
    <svg
      style={style}
      {...props}
      {...expandDataProps(data)}
    >
      <use xlinkHref={`#icon-${name}`} />
    </svg>
  );

  return (
    props.href ?
      <a
        className="svg-dynamic-icon__link"
        href={props.href}
        rel="noopener noreferrer"
        {...targetProps}
        {...expandDataProps(data)}
      >
        {icon}
      </a> :
      icon
  );
};

export default SVGDynamicIcon;
